import { render } from "./BoxEditor.vue?vue&type=template&id=c6e30956&scoped=true&ts=true"
import script from "./BoxEditor.vue?vue&type=script&lang=ts"
export * from "./BoxEditor.vue?vue&type=script&lang=ts"

import "./BoxEditor.vue?vue&type=style&index=0&id=c6e30956&lang=less&scoped=true"

import exportComponent from "/root/.jenkins/workspace/test-saas-doctor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6e30956"]])

export default __exports__